/* @ngInject */
export function authenticatedUser(authenticatedUserService, $stateParams) {
    if(!$stateParams.id){
        return null;
    }
    return authenticatedUserService.get($stateParams.id);
}

/* @ngInject */
export function installationsForAuthenticatedUser(authenticatedUserService, $stateParams) {
    return authenticatedUserService.getInstallationsForUser($stateParams.id);
}

/* @ngInject */
export function getUuid(uuidService) {
    return uuidService.getRandomUuid();
}

/* @ngInject */
export function getEmail(contactPointService, $stateParams) {
    return contactPointService.requestEmail();
}

/* @ngInject */
export function getApprovalForUsername(passwordCredentialsService) {
    return passwordCredentialsService.getApprovalForUsername();
}

/* @ngInject */
export function installationUsers(installationService) {
    return installationService.getInstallationUsers();
}

/* @ngInject */
export function destinationRedirectData(redirectService) {
    return redirectService.resolveRedirectUrl();
}

/* @ngInject */
export function getSecurityContext(passwordCredentialsService) {
    return passwordCredentialsService.getUserSecurityContext();
}
